import React, { useState, useEffect } from 'react'

import Tick from 'components/common/Tick/Tick'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { VIDEO_CALL, WHITEBOARD } from 'services/webSockets/roomState/constants'
import { dispatchRoomState } from 'store/dispatcher'

import './WhiteboardModeButton.css'

import {
    WhiteboardButton,
    WhiteboardIcon,
    WrapperDiv,
    TickMarkWrapper,
    WhiteboardModesText,
} from '../styles'

export default function WhiteboardModeButton(props) {
    const {
        setWhiteboardMode,
        roomModeState,
        isWhiteboardMode,
    } = useVideoContext()
    const [isWBEnabled, setIsWBEnabled] = useState(false)

    useEffect(() => {
        if (roomModeState === 'whiteboard') {
            setIsWBEnabled(true)
        }
    }, [])

    useEffect(() => {
        setIsWBEnabled(isWhiteboardMode)
    }, [isWhiteboardMode])

    const whiteboardHandle = () => {
        if (props.disabled) return

        setWhiteboardMode(!isWBEnabled)
        if (!isWBEnabled) {
            dispatchRoomState(WHITEBOARD)
        } else {
            dispatchRoomState(VIDEO_CALL)
        }
        setIsWBEnabled(!isWBEnabled)
        props.togglePopupOpened()
    }

    console.count('WhiteboardModeButton Component')

    return (
        <div className="isNewTagMenu">
            <WrapperDiv>
                <TickMarkWrapper>{isWBEnabled && <Tick />}</TickMarkWrapper>
                <WhiteboardButton
                    disabled={props.disabled}
                    onClick={whiteboardHandle}
                    clicked={isWBEnabled}
                >
                    <WhiteboardIcon
                        clicked={isWBEnabled}
                        src="/assets/controls/latest/create.svg"
                        alt="whiteboard button"
                    />
                </WhiteboardButton>
                <WhiteboardModesText
                    onClick={whiteboardHandle}
                    isClicked={isWBEnabled}
                >
                    Open Whiteboard
                </WhiteboardModesText>
            </WrapperDiv>
        </div>
    )
}
